import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./style.css";

import ProfileIcon from "../../../components/media/my-vodafone.png";
import LocationChangeListener from "../../../components/LocationChangeListener";

const LoggedInProfile = ({ className, link, subLinkList }) => {
  const [isOpen, setIsOpen] = useState(false);

  const hideFlyout = () => {
    setIsOpen(false);
  };

  const toggleFlyout = () => {
    setIsOpen((state) => !state);
  };

  return (
    <>
      <LocationChangeListener onChange={hideFlyout} />
      <span id="profile-icon-btn" className={className} onClick={toggleFlyout}>
        {link}
      </span>
      <div
        className={classnames("profile-flyout", {
          "nav-display": isOpen,
        })}
        onMouseLeave={hideFlyout}
      >
        <div className="vf-h5">Du bist eingeloggt</div>
        {subLinkList}
      </div>
    </>
  );
};

LoggedInProfile.propTypes = {
  className: PropTypes.string,
  link: PropTypes.node,
  subLinkList: PropTypes.node,
};

LoggedInProfile.defaultProps = {
  className: null,
  link: null,
  subLinkList: null,
};

export default LoggedInProfile;
